module.exports = __webpack_public_path__ + "static/media/AssignCarsTemplate.5e6eafa3.csv";